import Price from '../shop/Price';

type Props = {
  items: ICartItem[],
  subtotal?: number
}


const InvoiceReviewSubtotal = ({ items, subtotal }: Props) => {
  // Prefer the server-recorded subtotal; recompute from line items only when
  // the order carries no server total.
  if (subtotal !== undefined) {
    return <Price price={subtotal} showZero />;
  }
  // const subtotal = items.filter(item => !item.item.name.startsWith("Shipping")).reduce((subtotal, item) => subtotal + (item.count * (item.item.price ? item.item.price : 0)), 0);
  const computed = items.reduce((subtotal, item) => subtotal + (item.count * (item.item.price ? item.item.price : 0)), 0);

  return (
    <Price price={computed}/>
  )
}

export default InvoiceReviewSubtotal